import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ProductComment } from '@app/app/pdp/pdp-model';
import { DeviceService, EventTrackerService, HttpService } from '@app/core';
import { TokenService } from '@app/core/token/token.service';

@Component({
  selector: "navaar-comment-template",
  templateUrl: "./comment-template.component.html",
  styleUrls: ["./comment-template.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('more_desc', [
      state('open', style({ 'max-height': '999px' })),
      transition('* => open', [animate('1000ms ease-in')])
    ])
  ]
})
export class CommentTemplateComponent implements OnInit {
  @Input() public comment: ProductComment;
  @Input() public url: string;
  public moreTextDesc: 'open';
  public likesCount: number;
  public dislikesCount: number;
  public isliked: boolean;
  public isDisliked: boolean;
  public isActive = [];
  constructor(
    private readonly tokenService: TokenService,
    private readonly device: DeviceService,
    private readonly eventTracker: EventTrackerService,
    private readonly chkd: ChangeDetectorRef,
    private readonly http: HttpService
  ) { }

  ngOnInit() {
    this.likesCount = this.comment.likeCount;
    this.dislikesCount = this.comment.dislikeCount;
    this.isliked =
      this.comment.isCommentLikedByUser != null &&
      this.comment.isCommentLikedByUser;
    this.isDisliked =
      this.comment.isCommentLikedByUser != null &&
      !this.comment.isCommentLikedByUser;
    for (let i = 0, len = this.comment.replies?.length; i < len; i++) {
      this.isActive[i] = false;
    }
  }
  public moreText() {
    this.eventTracker.logEvent("x_btn_more_comment", {
      item_id: this.comment.audiobookId,
      comment_id: this.comment.audiobookId,
      count_like_comment: this.comment.likeCount,
      count_disLike_comment: this.comment.dislikeCount,
    });
    this.moreTextDesc = 'open';
  }
  public setActiveMoreTextReplies(idx) {
    this.eventTracker.logEvent("x_btn_more_comment", {
      item_id: this.comment.audiobookId,
      comment_id: this.comment.audiobookId,
      count_like_comment: this.comment.likeCount,
      count_disLike_comment: this.comment.dislikeCount,
    });
    for (let i = 0, len = this.isActive.length; i < len; i++) {
      if (i === idx) {
        this.isActive[i] = !this.isActive[i];
      }
    }
  }
  public clickedlike() {
    this.eventTracker.logEvent("x_btn_like_comment", {
      item_id: this.comment.audiobookId,
      comment_id: this.comment.audiobookId,
      count_like_comment: this.comment.likeCount,
      count_disLike_comment: this.comment.dislikeCount,
      is_login: this.tokenService.isLogin
    });
    if (this.tokenService.isLogin) {
      this.http
        .patch(`/api/ratereview/like/${this.comment.commentId}`)
        .subscribe((c) => this.statusColorIcon(c, true));
    } else
      this.device.goTologinPageNative(this.url);
  }
  public clickedDislike() {
    this.eventTracker.logEvent("x_btn_dislike_comment", {
      item_id: this.comment.audiobookId,
      comment_id: this.comment.audiobookId,
      count_like_comment: this.comment.likeCount,
      count_disLike_comment: this.comment.dislikeCount,
      is_login: this.tokenService.isLogin
    });
    if (this.tokenService.isLogin) {
      this.http
        .patch(`/api/ratereview/Dislike/${this.comment.commentId}`)
        .subscribe((c) => this.statusColorIcon(c, false));
    } else
      this.device.goTologinPageNative(this.url);
  }

  private statusColorIcon(c: any, islike: boolean) {
    const statusLikes = this.comment.isCommentLikedByUser;
    this.likesCount = c.likesCount;
    this.dislikesCount = c.dislikesCount;
    if (islike) {
      if (statusLikes == null || !statusLikes) {
        this.isDisliked = false;
        this.isliked = true;
        this.comment.isCommentLikedByUser = true;
      } else {
        this.isDisliked = false;
        this.isliked = false;
        this.comment.isCommentLikedByUser = null;
      }
    } else if (!islike) {
      if (statusLikes == null || statusLikes) {
        this.isDisliked = true;
        this.isliked = false;
        this.comment.isCommentLikedByUser = false;
      } else {
        this.isDisliked = false;
        this.isliked = false;
        this.comment.isCommentLikedByUser = null;
      }
    }
    this.chkd.detectChanges();
  }
}
